import React, { useEffect, useState, useRef, useMemo} from 'react';
import { useTranslation } from 'react-i18next'
import axios from '../../../plugins/axios'
import cloneDeep from 'lodash/cloneDeep';
import { wardSuspendState ,monitorState,wardState,unitState,globalConnectedDeviceState, deviceModelInfo  } from '../../../plugins/recoil';
import { useRecoilState } from 'recoil';
import Toast from '../../../plugins/useToast';
import { useBedData } from '../../../context/BedDataContext';
import { mmHgToKPa, celsiusToFahrenheit, percentTommHg,percentToKpa,mmHgToPercent, pad } from '../../../plugins/common';
import {ReactComponent as IconArrowUp} from '../../../assets/icons/ic-arrow-up.svg'
import {ReactComponent as IconArrowDown} from '../../../assets/icons/ic-arrow-down.svg'
import {ReactComponent as IconCheck} from '../../../assets/icons/ic-check_blue.svg';
import { ReactComponent as IconConnected } from "../../../assets/icons/ic_plug_on.svg";
import { ReactComponent as IconDisConnected } from "../../../assets/icons/ic_plug_off.svg";

const AlarmSettingsV2 = ({wardSettings,onSaveSuccess, handleSaveParameter}) => {    
    const { t } = useTranslation()  
    const isFirstRender = useRef(true);
    const [isDisabled, setIsDisabled] = useState(true);
    const [curWard,] = useRecoilState(wardState)
    const [curMonitor,] = useRecoilState(monitorState)
    const [wardSuspend, ] = useRecoilState(wardSuspendState);
    const { getBedData, version } = useBedData()
    const [globalConnectedDevice,] = useRecoilState(globalConnectedDeviceState);
    const [units,] = useRecoilState(unitState)
    const [isScrolling, setIsScrolling] = useState(false); //스크롤로 체크해서 그림자를 주기 위함.
    const [dashboard, setDashBoard] = useState()
    const [alarmCodeList, setAlarmCodeList] = useState();
    const [originalDeviceAlarms, setOriginalDeviceAlarms] = useState([]); // 원본 알람 설정 살태
    const [changeDeviceAlarms, setChangeDeviceAlarms] = useState([]); // 변경된 알람 설정 상태    
    const [defaultAlarms, setDefaultAlarms] = useState([]); // 기본 알람 설정 상태      
    const [limitRange, setLimitRange] = useState([]) // DropDown 데이터    
    const [openDropdown, setOpenDropdown] = useState({ group: null, key: null });
    const dropdownRefs = useRef({});
    const [deviceModelMenus, ] = useRecoilState(deviceModelInfo);
    const bedData = getBedData() 

    console.log('deviceModelMenus : ',deviceModelMenus);

    // ✅ Alarm List가 없을 시 Table Header 만들기 위한 코드
    const alarmEmptyOrder = [
        'HR', 'Arrhythmia', 'SpO2', 'RR', 'awRR', 'NIBP SYS', 'NIBP MAP', 'NIBP DIA',
        'IBP1 SYS', 'IBP1 MEAN', 'IBP1 DIA', 'IBP2 SYS', 'IBP2 MEAN', 'IBP2 DIA',
        'EtCO2', 'InCO2', 'IPI', 'Temp1', 'Temp2', 'IBP3 SYS', 'IBP3 MEAN', 'IBP3 DIA',
        'IBP4 SYS', 'IBP4 MEAN', 'IBP4 DIA', 'GasCO2Ex', 'GasCO2In', 'GasAA1Ex',
        'GasAA1In', 'GasAA2Ex', 'GasAA2In', 'GasO2Ex', 'GasO2In', 'GasN2OEx', 'GasN2OIn',
    ];        

    // ✅ AlarmList 세팅 (기존, 선택 된 것,Default 값)
    const setAlarmList = async () => {
        try{
            //Dashboard에 있는 devices가져와서 AlarmList를 가져온다.                
            const sortedDevices = Array.isArray(dashboard?.devices) ? [...dashboard.devices].sort((a, b) => (a.displayOrder ?? 0) - (b.displayOrder ?? 0)): []; // ✅ Device로 그냥 가져오니, 순서가 맞지 않아서 sort를 시켜주었음.
            const devices = sortedDevices.map(device => device.deviceId);            
            
            if(devices.length == 0){
                return false;
            }

            const params = new URLSearchParams();
            devices.forEach(id => params.append('deviceIds', id));
            const alarmRes = await axios.get(`/device/alarms?${params.toString()}`);       
            if( alarmRes.code !== 200) throw alarmRes;        
            
                //Default값 가져오기. (비교 분석을 위함과 코드 리스트를 가져오기 위함.)
            const defaultAlarmRes = await axios.get(`/measure/parameters/alarm`);
            if (defaultAlarmRes.code != '200') throw Toast({ isSuccess: false, msg : defaultAlarmRes });
            
            const parameters = defaultAlarmRes.data.parameters;
            setDefaultAlarms(parameters);            

                //th 세팅을 위한 AlarmCodeList 
            setAlarmCodeList(
                defaultAlarmRes.data.parameters.map(param => {                    
                    return {
                        measureParameterId: param.measureParameterId,
                        parameter: param.parameter,
                        measurementUnit: param.measurementUnit,
                        displayOrder: param.displayOrder,                        
                    }                    
                })
            );

                //DropDown 선택 값을 만들기 위한 Limit Range Data 만들기
            const LimitRange = makeAllRangeOptions(defaultAlarmRes.data.parameters);            
            setLimitRange(LimitRange); //DropDown Data                             
            // Device model 정보도 필요하여 병합 함 
            const alarmList = devices
                .map(deviceId => {
                    const alarm = alarmRes.data.devicesMeasureAlarms.find(d => d.deviceId === deviceId);
                    if (!alarm) return null;
                    const device = sortedDevices.find(d => d.deviceId === deviceId);
                    return {
                        ...alarm,
                        deviceModel: device ? device.deviceModel : undefined
                    };
                })
                .filter(Boolean); // ✅ 현재 보여지는 Dashboard 순서대로 List 정렬             

            const mergedData = mergeAlarmData(alarmList, parameters);        
                //깊은 복사를 위함.
            const deepCopiedMergedData = cloneDeep(mergedData);

            const converted = Object.fromEntries(
            Object.entries(deepCopiedMergedData).map(([deviceId, device]) => [
                deviceId,
                    {
                        ...device,
                        measureAlarmValues: Object.fromEntries(
                            (device.measureAlarmValues || []).map(item => [item.parameter, item])
                        )
                    }
                ])
            );                        

                // 원본 알람 설정 상태와 변경된 알람 설정 상태 세팅
            setOriginalDeviceAlarms(converted);
            setChangeDeviceAlarms(mergedData);
        }catch(err) {
            console.error(err);
        }
    }
    // ✅ Limit Select Option Data 만들기
    const makeAllRangeOptions = (paramList) => {
        return paramList.reduce((acc, param) => {
            const { parameter, minLimit, maxLimit, step } = param;
            // min이 null, undefined, '' 등 falsy면 0으로 처리
            const safeMin = (minLimit ?? 0);
            const safeMax = (maxLimit ?? 0);
            const safeStep = (step ?? 1);
            const limits = [];                                   

                //option 값 생성. value label
            for (let v = safeMin; v <= safeMax; v = +(v + safeStep).toFixed(10)) {
                const value = Number(v);
                const label = convertUnit(parameter,value,'label');
                limits.push({ value, label });
            }
            
            acc[parameter] = limits;
            return acc;
        }, {});
    }

    // ✅ 사용자 세팅의 의한 Alarm 단위 변경하는 함수. (단위의 Unit만 필요한 경우도 있어서 2개로 분기 나눠둠.)
    const convertUnit = (parameter,value,type = 'label') => {
        const nibpSeries = ['NIBPSYS', 'NIBPMAP', 'NIBPDIA']
        const ibpSeries = ['IBP1SYS', 'IBP1MEAN', 'IBP1DIA', 'IBP2SYS','IBP2MEAN', 'IBP2DIA','IBP3SYS', 'IBP3MEAN', 'IBP3DIA', 'IBP4SYS', 'IBP4MEAN', 'IBP4DIA']
        const co2Series = ['EtCO2', 'InCO2']
        const tempSeries = ['Temp1', 'Temp2']
        const gasSeries = ['GasCO2Ex','GasCO2In','GasAA1Ex','GasAA1In','GasAA2Ex','GasAA2In','GasO2Ex','GasO2In','GasN2OEx','GasN2OIn']
        const otherSeries = ['HR', 'RR', 'awRR', 'SpO2', 'Arrhythmia', 'IPI']

            //함수를 유동적으로 사용해보고 싶어서 써봄.
        const convertFunctions = {
            mmHgToKPa,
            celsiusToFahrenheit,
            percentTommHg,
            percentToKpa,
            mmHgToPercent
        };

        let unit = undefined;
        let functionName = undefined;

        if (nibpSeries.includes(parameter)) {
            unit = units["NIBP"];
            if(unit === 'kPa') {
                functionName = 'mmHgToKPa'; // mmHg를 kPa로 변환하는 함수
            }
        } else if (ibpSeries.includes(parameter)) {
            const prefix = parameter.match(/^IBP[1-4]/)?.[0];  // "IBP1", "IBP2" 등 추출
            // if(prefix == 'IBP2'){
            //     console.log('units[prefix] : '  , units[prefix]);
            // }            
            unit = units[prefix];
            if(unit === 'kPa') {
                functionName = 'mmHgToKPa'; // mmHg를 kPa로 변환하는 함수
            }
        } else if (co2Series.includes(parameter)) {
            unit = units[parameter];
            if(unit === 'kPa') {
                functionName = 'mmHgToKPa'; // mmHg를 kPa로 변환하는 함수
            }
            else if(unit === '%'){
                functionName = 'mmHgToPercent'; // mmHg를 %로 변환하는 함수
            }
        } else if (tempSeries.includes(parameter)) {
            unit = units[parameter];
            if(unit === '°F') {
                functionName = 'celsiusToFahrenheit'; // mmHg를 kPa로 변환하는 함수
            }
        } 
        else if (gasSeries.includes(parameter)) {
            unit = units["GAS"];            
            if(unit === 'mmHg') {
                functionName = 'percentTommHg'; // mmHg를 kPa로 변환하는 함수
            }
            else if(unit === 'kPa'){
                functionName = 'percentToKpa';
            }  
        } else if(otherSeries.includes(parameter)) {
            unit = units[parameter];
        }

        if(type == 'unit'){
            return unit;
        }else if(type == 'label'){
            let label = value;            
            if (functionName && typeof convertFunctions[functionName] === 'function') {
                label = convertFunctions[functionName](value);
            }
            
            // if(parameter == 'IBP2SYS'){
            //     console.log('label : ', label);
            // }
            return label;
        }
    }
    
    // ✅ API에서 Alarm ID만 주고 이름은 알 수 없어서 병합하는 함수.
    const mergeAlarmData = (alarmList, parameters) => {
        const paramMap = {};
        parameters.forEach(param => {
            paramMap[param.measureParameterId] = param;
        });        

        // 배열로 반환 (deviceId 순서 유지)
        return alarmList.map(device => {
            const measureAlarmValues = (device.measureAlarmValues || []).map(alarm => {
                const param = paramMap[alarm.measureParameterId];
                return param
                    ? {
                        ...alarm,
                        parameter: param.parameter,
                        measurementUnit: param.measurementUnit,
                        minLimit: param.minLimit,
                        maxLimit: param.maxLimit,
                        displayOrder: param.displayOrder,
                    }
                    : alarm;
            });

            return {
                ...device,
                measureAlarmValues
            };
        });
    };
    
    // ✅ DashBoard가 Render될 때 WardSetting을 가져와서 현재 모니터에 맞는 WardSetting을 가져온다.
    useEffect(() => {          
        const monitorSetting = Array.isArray(wardSettings)
        ? wardSettings.find(setting => setting.displayOrder === curMonitor)
        : wardSettings;
    
        setDashBoard(monitorSetting);
    }, [wardSettings])

    // ✅ Dashboard가 세팅 되면 AlarmList를 세팅한다.
    useEffect(() => {
            //최초 Render 시에는 비활성화
        if (isFirstRender.current) {
            isFirstRender.current = false;
            return;
        }

        setAlarmList();

            // 스크롤 이벤트로 그림자 효과 추가
        const tableContainer = document.querySelector('.scrollbar-shadow');
        const handleScroll = () => {
            setIsScrolling(tableContainer.scrollLeft > 0);
        };

            // console.log(groupedAlarmData);
        tableContainer.addEventListener('scroll', handleScroll);
        return () => {
            tableContainer.removeEventListener('scroll', handleScroll);
        };
    }, [dashboard])    

    // ✅ 변경된 알람 설정 상태가 있는지 확인하여 저장 버튼 활성화/비활성화
    useEffect(() => {
        let hasChange = false;

        for (const changeDevice of changeDeviceAlarms) {
            const { deviceId, suspended, measureAlarmValues } = changeDevice;

            const originalDevice = Object.values(originalDeviceAlarms).find(
                dev => dev.deviceId === deviceId
            );

            const originalAlarmsMap = originalDevice?.measureAlarmValues || {};

            const isAnyChanged = measureAlarmValues.some(alarm => {
                const originalAlarm = originalAlarmsMap[alarm.parameter];
                if (!originalAlarm) return true;
                return (
                    alarm.min !== originalAlarm.min ||
                    alarm.max !== originalAlarm.max
                );
            });

            const suspendedChanged = originalDevice?.suspended !== suspended;

            if (isAnyChanged || suspendedChanged) {
                hasChange = true;
                break;
            }
        }

        setIsDisabled(!hasChange);
    }, [changeDeviceAlarms]);       
    
    // ✅ Save 이벤트 핸들러
    const handleSave = async () => {
        try{
            const devicesMeasureAlarms = [];

            changeDeviceAlarms.forEach(changeDevice => {
                if (!globalConnectedDevice.includes(changeDevice.deviceId)) return;

                const { deviceId, suspended, measureAlarmValues } = changeDevice;
                const originalDevice = Object.values(originalDeviceAlarms).find(
                    dev => dev.deviceId === deviceId
                );

                const originalAlarmsMap = originalDevice?.measureAlarmValues || {};

                const isAnyChanged = measureAlarmValues.some(alarm => {
                    const originalAlarm = originalAlarmsMap[alarm.parameter];
                    if (!originalAlarm) return true;
                    return (
                        alarm.min !== originalAlarm.min ||
                        alarm.max !== originalAlarm.max
                    );
                });

                const suspendedChanged = originalDevice?.suspended !== suspended;

                // 하나라도 변경된 값이 있거나 suspended가 변경됐으면 전체 measureAlarmValues를 payload에 포함
                if (isAnyChanged || suspendedChanged) {
                    devicesMeasureAlarms.push({
                        deviceId,
                        suspended,
                        measureAlarmValues: measureAlarmValues.map(alarm => ({
                            measureParameterId: alarm.measureParameterId,
                            min: alarm.min,
                            max: alarm.max
                        }))
                    });
                }
            });

            const payload = { devicesMeasureAlarms };            
            console.log('payload : ', payload);

            // 실제 저장 API 호출
            const res = await axios.put('/device/alarms', payload);
            if (res.code !== 200) throw res;

            Toast({ isSuccess: true});
            setIsDisabled(true);
            handleSaveParameter()
            if (onSaveSuccess) onSaveSuccess();
        }
        catch(err) {
            console.error('Save failed:', err);
            Toast({ isSuccess: false, msg: err.message });
        }
    }
    
    // ✅ LimitDropdown 컴포넌트
    function LimitDropdown(value,oppoValue,type,paramKey,rowIdx,alarmIdx,deviceId,measureParameterId,disabled = false) {
        const dropdownKey = type+paramKey+deviceId;
        if (!dropdownRefs.current[dropdownKey]) {
            dropdownRefs.current[dropdownKey] = React.createRef();
        }        
        const thisDropdownRef = dropdownRefs.current[dropdownKey];      
        const isConnected = (Array.isArray(globalConnectedDevice) ? globalConnectedDevice : []).includes(deviceId); //이걸로 비활성화 시킬 수 있을 것 같은데.      

        return (            
            <div className="relative h-[30px] " ref={thisDropdownRef}>
                <div className="text-[#DEDEDE] px-[4px] py-[7px] rounded-[6px] cursor-pointer flex items-center justify-evenly group"                    
                    onClick={() => {
                        if(isConnected && !disabled){
                            setOpenDropdown(prev =>
                                prev.key === type+paramKey+deviceId
                                    ? { group: null, key: null } // 이미 열려있으면 닫기
                                    : { group: null, key: type+paramKey+deviceId } // 아니면 열기
                            );
                        }
                    }}
                >                    
                    <div className="w-full text-right">{convertUnit(paramKey,value)}</div>                    
                    <div
                        className={`
                            ml-[6px] pointer-events-none                            
                            ${openDropdown.key === type+paramKey+deviceId
                                ? 'opacity-100'
                                : 'opacity-0 group-hover:opacity-100'
                            }
                            block
                        `}
                    >
                        <span className={`${!disabled ? 'visible' : 'invisible'}`}>
                            {openDropdown.key === type+paramKey+deviceId ? <IconArrowUp /> : <IconArrowDown />} 
                        </span>
                    </div>                    
                </div>
                {openDropdown.key === type+paramKey+deviceId && (
                    <div className="gender-dropdow absolute scrollbar scrollbar-10px max-h-[150px] overflow-y-auto top-[35px] bg-[#1F1F1F] w-full py-[8px] rounded-[6px] border border-[#5E5E5E] shadow-[0px_12px_12px_0px_rgba(0,0,0,0.4)] z-20">                                            
                        {limitRange[paramKey] && limitRange[paramKey]
                            .filter(limit => {
                                if (type === 'max') {
                                    if(['Arrhythmia', 'GasO2Ex', 'GasO2In'].includes(paramKey)){
                                        return limit.value >= oppoValue; // oppoValue(=min)보다 큰 값만
                                    }else{
                                        return limit.value > oppoValue; // oppoValue(=min)보다 큰 값만
                                    }
                                } else if (type === 'min') {
                                    if(['IPI'].includes(paramKey)){
                                        return true;
                                    }else{
                                        return limit.value < oppoValue; // oppoValue(=max)보다 작은 값만
                                    }
                                }
                                return true;
                            })                                                        
                            .map((limit, index) => {
                                // alarmIdx 대신 measureParameterId로 해당 알람을 찾음
                                const alarm = changeDeviceAlarms[rowIdx].measureAlarmValues.find(
                                    a => a.measureParameterId === measureParameterId
                                );
                                const isSelected = alarm && alarm[type] === limit.value;
                                return (
                                    <div
                                        key={`${paramKey}-${index}`}
                                        className={`bg-[#1F1F1F] cursor-pointer h-[32px] flex items-center justify-between px-[8px] hover:bg-[#2F2F2F] 
                                            ${isSelected ? "text-[#3182F7] selected-option" : "text-white"}`}
                                        onClick={() => {
                                            setChangeDeviceAlarms(prev => {
                                                return prev.map((item, idx) => {
                                                    if (idx !== rowIdx) return item;
                                                    
                                                    // measureParameterId로 해당 알람 찾기
                                                    const newMeasureAlarmValues = item.measureAlarmValues.map(alarm => {
                                                        if (alarm.measureParameterId !== measureParameterId) return alarm;
                                                        return { ...alarm, [type]: limit.value };
                                                    });

                                                    // ✅ 동기화 처리: RESP ↔ awRR
                                                    const syncPairs = [
                                                        ['RESP', 'awRR'],
                                                    ];

                                                    const curParam = newMeasureAlarmValues.find(a => a.measureParameterId === measureParameterId)?.parameter;
                                                    const pair = syncPairs.find(([a, b]) => curParam === a || curParam === b);

                                                    if (pair) {
                                                        const [a, b] = pair;
                                                        const target = curParam === a ? b : a;
                                                        const targetAlarm = newMeasureAlarmValues.find(alarm => alarm.parameter === target);

                                                        if (targetAlarm) {
                                                            // 동일한 type(max/min)의 값을 동기화
                                                            targetAlarm[type] = limit.value;
                                                        }
                                                    }

                                                    return { ...item, measureAlarmValues: newMeasureAlarmValues };
                                                });
                                            });
                                            setOpenDropdown({ group: null, key: null });
                                        }}
                                    >
                                        {limit.label}
                                        {isSelected && (
                                            <IconCheck className="w-4 h-4 ml-2" />
                                        )}
                                    </div>
                                )
                            })
                        }                       
                    </div>
                )}
            </div>
        )
    }   

    // ✅ select box 클릭 시 꺼지게.
    useEffect(() => {
        function handleClickOutside(event) {
            if (openDropdown.key && dropdownRefs.current[openDropdown.key]) {
                const ref = dropdownRefs.current[openDropdown.key];
                if (ref.current && !ref.current.contains(event.target)) {
                    setOpenDropdown({ group: null, key: null });
                }
            }
        }

        // ✅ 드롭다운이 열릴 때 선택된 옵션으로 스크롤 이동
        if (openDropdown.key && dropdownRefs.current[openDropdown.key]) {
            const ref = dropdownRefs.current[openDropdown.key];
            if (ref.current) {
                const selected = ref.current.querySelector('.selected-option');
                if (selected) {
                    selected.scrollIntoView({ block: 'nearest' });

                    // 추가 스크롤
                    // const parent = selected.parentElement;
                    // if (parent && typeof parent.scrollTop === 'number') {
                    //     parent.scrollTop = parent.scrollTop + 150; //추가 스크롤 만큼
                    // }
                }
            }
        }

        if (openDropdown.key) {
            document.addEventListener('mousedown', handleClickOutside);
        } else {
            document.removeEventListener('mousedown', handleClickOutside);
        }
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [openDropdown]);
    
    const thClasses = "px-2 py-2 !font-light border-r border-b border-[#444444] box-border";

    //그려주는건 Change 기준으로 보여줘야 될 것 같음.
    return (
        <div className="relative w-full h-full">
            <div className="scrollbar scrollbar-shadow" style={{ height: 'calc(100%)' }}>
                <table className="table-fixed w-full text-center text-[#DEDEDE] border-separate border-spacing-0">
                    <thead className={`h-[63px] sticky top-0 z-[30] p-2 text-[14px] leading-[14.5px] border-b border-[#444444]`}>
                        <tr>                            
                            <th className={`${thClasses} sticky left-0 top-0 z-[30] bg-[#262626] w-[124.5px]`}>{t('setting.ward')}</th>
                            <th className={`${thClasses} sticky left-[124.5px] z-20 bg-[#262626] w-[124.5px] whitespace-nowrap`}>{t('setting.bedNo')}</th>
                            <th className={`${thClasses} sticky left-[248.5px] z-20 bg-[#262626] w-[124.5px]`}>{t('setting.connection')}</th>
                            <th className={`${thClasses} sticky left-[373px] z-20 bg-[#262626] px-4 w-[180px] ${isScrolling ? 'shadow-[8px_0px_8px_0px_rgba(0,0,0,0.2)]' : ''}`}>{t('setting.name')}</th>
                            <th className={`${thClasses} bg-[#262626] w-[80px] `}>{t('setting.alarmOff')}</th>
                            
                            {
                                alarmCodeList ? alarmCodeList.map((alarm) => {                                                                        
                                    const unit = convertUnit(alarm.parameter, '_', 'unit');
                                    return (
                                        <th key={alarm.parameter} className={`${thClasses} bg-[#262626] w-[116px] !p-0`}>
                                            <div className="flex flex-col justify-center w-full h-full">
                                                <div className="h-[42px] flex items-center justify-center border-b border-[#444444]">                                                    
                                                    <div className='w-[80px]'>
                                                        {alarm.parameter}     
                                                        {
                                                            (unit || alarm.measurementUnit) ? (
                                                                <div>
                                                                    {unit ? `(${unit})` : ''}
                                                                </div>
                                                            ) : null
                                                        }           
                                                    </div>
                                                </div>
                                                <div className="flex h-[20px] justify-center items-center">
                                                    <div className={`w-[59px] h-full text-[12px] text-[#9f9f9f] font-light text-center pt-[2px] border-r border-[#444444]`}>{t('setting.max')}</div>
                                                    <div className="h-full text-[12px] text-[#9f9f9f] font-light text-center pt-[2px] w-[59px]">{t('setting.min')}</div>
                                                </div>
                                            </div>
                                        </th>
                                    )
                                }) : 
                                alarmEmptyOrder.map((alarm, idx) => {
                                    return (
                                        <th className="px-2 py-2 !font-light border-r border-b border-[#444444] box-border bg-[#262626] w-[116px] !p-0" key={alarm}>
                                            <div className="flex flex-col justify-center w-full h-full">
                                                <div className="h-[42px] flex items-center justify-center border-b border-[#444444]">		
                                                    <div className="w-[80px]">{alarm}				
                                                </div>
                                                </div>
                                                <div className="flex h-[20px] justify-center items-center">
                                                    <div className={`w-[59px] h-full text-[12px] text-[#9f9f9f] font-light text-center pt-[2px] border-r border-[#444444]`}>{t('setting.max')}</div>
                                                    <div className="h-full text-[12px] text-[#9f9f9f] font-light text-center pt-[2px] w-[59px]">{t('setting.min')}</div>                                                    
                                                </div>
                                            </div>
                                        </th>
                                    )
                                })
                            }
                        </tr>
                    </thead>

                    <tbody>
                        {
                            changeDeviceAlarms && changeDeviceAlarms.map((row, rowIdx) => {
                                const rowBgColor = rowIdx % 2 === 0 ? 'bg-[#2F2F2F]' : 'bg-[#343434]';
                                const isConnected = (Array.isArray(globalConnectedDevice) ? globalConnectedDevice : []).includes(row.deviceId);     
                                const isModify = deviceModelMenus.find(item => item.model === row.deviceModel)?.alarmLimitModify;                            
                                return (
                                    <tr key={rowIdx} className={rowBgColor}>                                        
                                        <td className={`!font-light h-[30px] border-r border-[#444444] text-left flex items-center gap-1 sticky left-0 ${rowBgColor} z-20`}>                                        
                                            <div
                                                className="truncate"
                                                style={{                                                
                                                    display: 'block',
                                                }}
                                                title={curWard.label}
                                            >
                                                {curWard.label}
                                            </div>                                            
                                        </td>
                                        <td className={`!font-light px-2 h-[30px] border-r border-[#444444] sticky left-[124.5px] ${rowBgColor} z-20 text-left`}>       
                                            {
                                                row.bedNumber != null && (
                                                    <span>{`BED-${String(row.bedNumber).padStart(2, '0')}`}</span>
                                                )
                                            }
                                        </td>
                                        <td className={`!font-light px-2 h-[30px] border-r border-[#444444] sticky left-[248.5px] ${rowBgColor} z-20 text-center`}>                                        
                                            {isConnected ? <IconConnected className="inline-block" /> : <IconDisConnected className="inline-block" />}
                                        </td>                                        
                                        <td className={`!font-light px-2 h-[30px] border-r border-[#444444] sticky left-[373px] ${rowBgColor} z-20 text-left truncate ${isScrolling ? 'shadow-[8px_0px_8px_0px_rgba(0,0,0,0.2)]' : ''}`} title={row.patientName}>
                                            {row.patientName}
                                        </td>
                                        <td className={`${(!isModify || !isConnected) || (wardSuspend === '1' || bedData[row.serial]?.silenceData?.alarmPause === '1' || bedData[row.serial]?.silenceData?.audioPause === '1') ? `opacity-10` : ''} !font-light px-2 h-[30px] border-r border-[#444444]`}>
                                            <div className="flex items-center justify-center">
                                            <input
                                                type="checkbox"
                                                checked={(wardSuspend === '1' || bedData[row.serial]?.silenceData?.alarmPause === '1' || bedData[row.serial]?.silenceData?.audioPause === '1') ? true : row.suspended} // '0'이면 체크됨
                                                disabled={(!isModify || !isConnected) ? true : ((wardSuspend === '1' || bedData[row.serial]?.silenceData?.alarmPause === '1' || bedData[row.serial]?.silenceData?.audioPause === '1'))}
                                                onChange={() => { 
                                                    setChangeDeviceAlarms(prev => 
                                                        prev.map(item =>
                                                            item.deviceId === row.deviceId
                                                                ? { ...item, suspended: !item.suspended }
                                                                : item
                                                        )
                                                    );           
                                                }}
                                                />
                                            </div>
                                        </td>
                                        {                                                                                      
                                            alarmCodeList && alarmCodeList.map((alarm, alarmIdx) => {
                                                const isOnlyMax = ['Arrhythmia', 'GasO2Ex', 'GasO2In'].includes(alarm.parameter);                                                
                                                const isOnlyMin = ['IPI'].includes(alarm.parameter);
                                                const alarmData = row.measureAlarmValues.find(a => a.measureParameterId === alarm.measureParameterId);                                                                                            
                                                return alarmData ? (
                                                    <td key={alarm.parameter} className={`${(!isModify || !isConnected) ? `opacity-10` : ''} w-[116px] h-[30px] border-r border-[#444444] p-0 !font-light`}>
                                                        <div className="flex items-center justify-between">                                                           
                                                            {
                                                                // max, min 셀을 배열로 만들어 map으로 렌더링
                                                                ['max', 'min'].map(type => {
                                                                    // isOnlyMax면 min은 빈 div, isOnlyMin이면 max는 빈 div
                                                                    if ((type === 'max' && isOnlyMin) || (type === 'min' && isOnlyMax)) {
                                                                        return <div key={type} className="w-full"></div>;
                                                                    }
                                                                    const value = type === 'max' ? alarmData.max : alarmData.min;
                                                                    const oppoValue = type === 'max' ? alarmData.min : alarmData.max;
                                                                    const originalValue = originalDeviceAlarms[rowIdx].measureAlarmValues[alarm.parameter]?.[type];
                                                                    const changed = value != originalValue;
                                                                    return (
                                                                        <div
                                                                            key={type}
                                                                            className={`w-full ${changed ? 'bg-[#2F2F2F] bg-[linear-gradient(0deg,rgba(49,130,247,0.3)_0%,rgba(49,130,247,0.3)_100%)]' : ''}`}
                                                                        >
                                                                            {LimitDropdown(value, oppoValue, type, alarm.parameter, rowIdx, alarmIdx, row.deviceId, alarm.measureParameterId, (!isModify || !isConnected))}
                                                                        </div>
                                                                    );
                                                                })
                                                            }
                                                        </div>
                                                    </td>
                                                ) : (
                                                    <td></td>
                                                )
                                            })
                                        }
                                    </tr>
                                )
                            })
                        }
                    </tbody>
                </table>
            </div>
            <button className={`w-[88px] h-[28px] absolute top-[-35px] right-[20px] rounded-[6px] 
                    ${isDisabled? 'bg-[#1f1f1f] text-[rgba(255,255,255,0.2)] cursor-default shadow-none'
                    : ' text-white bg-gradient-to-b from-[#5E5E5E] to-[#383838] shadow-md transition-all duration-200'}
                    active:from-[#4A4A4A] active:to-[#2B2B2B] active:shadow-sm`}
                disabled={isDisabled}
                onClick={handleSave}
                >{isDisabled ? t('setting.saved') : t('setting.save')}
            </button>
        </div>
    );
};

export default AlarmSettingsV2;
